export const ALLOW_LANGUAGES_CODES = <const>['en', 'ru', 'uk']
export type TLanguage = (typeof ALLOW_LANGUAGES_CODES)[number]
